module.exports = __webpack_public_path__ + "static/media/p1.5f30c1d0.jpeg";